import type { BillingSummary } from '@kizen/api/billing';

type Money = BillingSummary['accrual_limit'];

export type BudgetSection = {
  budget_limit: Money | null;
  budget_usage: Money;
};

/**
 * Stats for a currency budget bar (overage categories). A null budget_limit
 * means unlimited (StatisticRow draws those bars); a $0 budget means overage
 * is not allowed.
 */
export const getBudgetStats = (section?: BudgetSection) => {
  const used = section?.budget_usage?.amount ?? 0;
  const currencySymbol = section?.budget_usage?.symbol;

  if (!section?.budget_limit) {
    return { percentage: 0, used, limit: Infinity, currencySymbol };
  }

  const limit = section.budget_limit.amount;

  if (limit === 0) {
    // Gray when nothing (or under a cent) is spent; red for real spend.
    const spentCents = Math.round(used * 100);
    return {
      percentage: spentCents > 0 ? 100 : 0,
      used,
      limit,
      currencySymbol,
    };
  }

  return { percentage: (used / limit) * 100, used, limit, currencySymbol };
};

/**
 * Stats for a count bar (steps, emails, credits, users). A falsy limit means
 * unlimited (StatisticRow draws those bars).
 */
export const getCountStats = (used?: number, limit?: number | null) => {
  const safeUsed = used ?? 0;

  if (!limit) {
    return { percentage: 0, used: safeUsed, limit: Infinity };
  }

  return { percentage: (safeUsed / limit) * 100, used: safeUsed, limit };
};
